"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartPointerEvent = void 0;
const rc_js_util_1 = require("rc-js-util");
const canvas_dimensions_1 = require("../../../templating/canvas-dimensions");
/**
 * @public
 * {@inheritDoc IChartPointerEvent}
 */
class ChartPointerEvent {
    constructor(canvasDims, pointerCssPosition, pointerClipPosition, $event) {
        this.canvasDims = canvasDims;
        this.pointerCssPosition = pointerCssPosition;
        this.pointerClipPosition = pointerClipPosition;
        this.$event = $event;
    }
    static createOneEmpty() {
        return new ChartPointerEvent(canvas_dimensions_1.CanvasDimensions.createDefault(), rc_js_util_1.Vec2.f32.factory.createOneEmpty(), rc_js_util_1.Vec2.f32.factory.createOneEmpty(), new PointerEvent("dummy"));
    }
    clone() {
        return new ChartPointerEvent(this.canvasDims.clone(), this.pointerCssPosition.slice(), this.pointerClipPosition.slice(), this.$event);
    }
}
exports.ChartPointerEvent = ChartPointerEvent;
//# sourceMappingURL=chart-pointer-event.js.map